
import MovementInfo from './MovementInfo';

export default MovementInfo;